import { api } from "./client";

export const authApi = {
  me: async () => {
    const res = await api.get("/auth/me");
    return res.data;
  },
  googleLoginUrl: async (redirectUri) => {
    const res = await api.get("/auth/google/login", {
      params: redirectUri ? { redirect_uri: redirectUri } : {},
    });
    return res.data;
  },
  session: async ({ code, state, redirectUri }) => {
    const res = await api.post("/auth/session", {
      code,
      state,
      redirect_uri: redirectUri,
    });
    return res.data;
  },
  logout: async () => {
    const res = await api.post("/auth/logout", {});
    return res.data;
  },
};
